import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import logoImage from '../assets/Logo.png';
import { useLanguage } from '../context/LanguageContext';
import translations from '../translations';

const NotFound = () => {
  const { lang } = useLanguage();
  const t = translations[lang];
  const isRTL = lang === 'ar';

  return (
    <div className={`bg-[#111820] min-h-screen flex flex-col items-center justify-center text-center px-4 ${isRTL ? 'font-arabic' : ''}`} dir={isRTL ? 'rtl' : 'ltr'}>
      <Helmet>
        <title>{t.notfound_title}</title>
      </Helmet>
      <img src={logoImage} alt="Technology Resources Logo" className="w-24 mb-8" />
      <h1 className="text-[#97d700] text-8xl font-bold mb-4">404</h1>
      <h2 className="text-white text-2xl font-semibold mb-4">{t.notfound_heading}</h2>
      <p className="text-gray-400 mb-8 max-w-md">{t.notfound_text}</p>
      <Link
        to="/"
        className="bg-[#97d700] text-black font-bold py-3 px-8 rounded hover:bg-green-400 transition duration-300"
      >
        {t.notfound_cta}
      </Link>
    </div>
  );
};

export default NotFound;
